import { render, staticRenderFns } from "./DispatchedOrderRow.vue?vue&type=template&id=badc6c6e"
import script from "./DispatchedOrderRow.vue?vue&type=script&lang=js"
export * from "./DispatchedOrderRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports